// Global app action types
export const RESET_APP_STATE = 'RESET_APP_STATE';



// WEBPACK FOOTER //
// ./src/store/actionTypes.js